import { useCallback, useState } from 'react';

const useStateMerger = <T>(initialState: T) => {
  const [listState, setter] = useState<T>(initialState);
  const mergeState = useCallback((state: Partial<T>) => {
    setter((prevState) => ({ ...prevState, ...state }));
  }, []);

  return [listState, mergeState] as const;
};

export default useStateMerger;
